export default (rows, headers) => {
    const rawValues = rows.map(row => {
        return row.split('\t')
    });

    return rawValues.map(row =>
        headers.reduce((acc, curr, index) => ({...acc, [curr]: (row[index] || '')}), {})
    );
};